import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ScanResultHeader} from './ScanResultHeader';
import {ScanResultInsights} from './ScanResultInsights';
import {ScanResultBoxes} from './ScanResultBoxes';
import {ScanResultBoxData, ConnectivityHeatmapData} from '../../../connectivity-guru.contracts';
import {ScanResultAdvancedButton} from './ScanResultAdvancedButton';
import {ITranslate} from '../../../../../services/LocalizationService';
import {HeatmapImages} from './HeatmapImages';
import './HeatmapImages.scss';
import {observer} from 'mobx-react';
import {LayeredImageController} from '../../../../../shared/image-layers/LayeredImageController';

interface ScanResultContainerProps {
    boxes: ScanResultBoxData[];
    insightsText: string;
    onClickAdvanced: () => void;
    id?: string;
    updatedDate?: Date;
    translate: ITranslate;
    getIconColor: (label: number) => string;
    setIsInsightsOpen: (label: boolean) => void;
    isInsightsOpen?: boolean;
    connectivityHeatmapData?: ConnectivityHeatmapData;
    showHeatmapImages?: boolean;
    onImageClick?: (imageUrl: string, imageLabel?: string) => void;
    layeredImageController: LayeredImageController;
}

@observer
export class ScanResultContainer extends TechseeBaseComponent<ScanResultContainerProps> {
    renderInternal() {
        const {
            boxes,
            translate,
            insightsText,
            onClickAdvanced,
            id,
            updatedDate,
            getIconColor,
            isInsightsOpen,
            setIsInsightsOpen,
            connectivityHeatmapData,
            showHeatmapImages,
            onImageClick,
            layeredImageController
        } = this.props;

        return (
            <div className={'wifi-analyzer-scan-wrapper'}>
                <ScanResultHeader
                    id={id ?? ''}
                    textHeader={translate('CONNECTIVITY_GURU.WIFI_SCAN.SCAN_RESULTS')}
                    translate={translate}
                    date={updatedDate}></ScanResultHeader>
                <ScanResultInsights
                    translate={translate}
                    text={insightsText}
                    isOpen={isInsightsOpen}
                    setIsInsightsOpen={setIsInsightsOpen}></ScanResultInsights>
                {showHeatmapImages && connectivityHeatmapData?.imageUrls ? (
                    <HeatmapImages
                        imageUrls={connectivityHeatmapData.imageUrls}
                        onImageClick={onImageClick}
                        translate={translate}
                        layeredImageController={layeredImageController}
                    />
                ) : (
                    <>
                        <ScanResultBoxes getIconColor={getIconColor} boxes={boxes}></ScanResultBoxes>
                        <ScanResultAdvancedButton
                            text={translate('CONNECTIVITY_GURU.WIFI_SCAN.ADVANCED_ANALYSIS')}
                            onClick={onClickAdvanced}></ScanResultAdvancedButton>
                    </>
                )}
            </div>
        );
    }
}
